<template>
  <search-summary-bar-link-matches
    v-if="ifGuests"
    :slug="slug"
    exclude-type="visibleMarker"
    data-test="summary-party"
    :aria-label="label"
  >
    <img
      v-if="isFamily"
      src="@/assets/images/family.svg"
      data-test="summary-party-image-family"
    />
    <img
      v-else-if="isOneAdultOnly"
      src="@/assets/images/adult.svg"
      data-test="summary-party-image-one-adult"
    />
    <img
      v-else-if="isAdultsOnly"
      src="@/assets/images/adults.svg"
      alt=""
      width="13"
      height="19"
      data-test="summary-party-image-adults-only"
    />
    <img
      v-else-if="isChildrenOnly"
      src="@/assets/images/children.svg"
      data-test="summary-party-image-children-only"
    />
    <img
      v-if="hasDogs"
      src="@/assets/images/dog.svg"
      data-test="summary-party-image-dog"
      class="search-summary-bar-dog-icon"
    />
  </search-summary-bar-link-matches>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SearchFilters } from '../../../apps/search/schemas'

@Component
class SearchSummaryBarDetailsGuests extends Vue {
  @Prop()
  searchFilters: SearchFilters

  @Prop({ required: false })
  slug?: string

  get hasDates(): boolean {
    const dates = this.searchFilters.dates
    if (!dates || (!dates.arrive && !dates.depart)) {
      return false
    }
    return true
  }

  get isFamily(): boolean {
    return this.adults >= 1 && this.children >= 1
  }

  get isOneAdultOnly(): boolean {
    return this.adults === 1 && this.children === 0
  }

  get isAdultsOnly(): boolean {
    return (this.adults >= 1 && this.children === 0) || this.isDefault2Adults
  }

  get isDefault2Adults(): boolean {
    return this.hasDates && this.adults === 0 && this.children === 0
  }

  get isChildrenOnly(): boolean {
    return this.adults === 0 && this.children >= 1
  }

  get hasDogs(): boolean {
    return this.dogs > 0
  }

  get ifGuests() {
    return (
      this.isFamily ||
      this.isOneAdultOnly ||
      this.isAdultsOnly ||
      this.isChildrenOnly
    )
  }

  get adults() {
    const party = this.searchFilters.party
    return party ? party.adults : 0
  }

  get children() {
    const party = this.searchFilters.party
    return party ? party.childAges.length : 0
  }

  get dogs() {
    const party = this.searchFilters.party
    return party?.dogs ? party.dogs : 0
  }

  get label() {
    const groupSize = this.adults + this.children
    return this.ifGuests && groupSize
      ? this.$t('{people} people', { people: groupSize })
      : ''
  }
}

export default toNative(SearchSummaryBarDetailsGuests)
</script>
<style scoped>
.search-summary-bar-dog-icon {
  margin-left: 0.35em;
}
</style>
